/** Canonical product feature keys returned by the backend access contract. */
export const ACCESS_FEATURES = Object.freeze({
  LIVE_TARGETS: 'dashboard.liveTargets',
  DAILY_REPORTS: 'dashboard.dailyReports',
  WEEKLY_REPORTS: 'dashboard.weeklyReports',
  HISTORY: 'dashboard.history',
});
